import { getIPInfo } from 'api/users'
import { useUserProfile } from 'hooks/useUserProfile'
import { useCallback, useEffect, useState } from 'react'
import { Fees } from 'utils/data'
import { defaultFees, getFeesFromProfile } from 'utils/fees'

export const useUserFees = (newCountry?: string) => {
  const { data: userProfile, isFetched } = useUserProfile()
  const [fees, setFees] = useState<Fees>(getFeesFromProfile(userProfile))
  const [isGB, setIsGB] = useState<boolean>()

  const setData = useCallback(
    (country?: string) => {
      const userProfileFees = getFeesFromProfile(userProfile)

      if (!country) {
        setFees(userProfileFees)
        setIsGB(false)
        return
      }

      const isCountryGb = ['UK', 'GB', 'United Kingdom'].includes(country)

      setFees({
        ...userProfileFees,
        processFee: isCountryGb
          ? defaultFees.processFee / 100
          : defaultFees.processFeeNonGb / 100,
      })
      setIsGB(isCountryGb)
    },
    [userProfile]
  )

  useEffect(() => {
    if (newCountry) {
      setData(newCountry)
      return
    }

    if (!isFetched) return

    if (userProfile?.shippingAddress?.country) {
      setData(userProfile.shippingAddress.country)

      return
    }

    const loadIPFees = async () => {
      const ipinfo = await getIPInfo()

      setData(ipinfo.country)
    }

    loadIPFees()
  }, [userProfile, isFetched, newCountry, setData])

  return { fees, isGB }
}
